import { actions } from './actions'

const initialState = {
  actividad: {
    data: [],
    loading: false,
    error: '',
  },
  erroneos: {
    data: [],
    loading: false,
    error: '',
  },
  procesados: {
    data: [],
    loading: false,
    error: '',
  },
  erroneosByOrigenDestino: {
    data: [],
    loading: false,
    error: '',
  },
  instancia: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function syncReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ACTIVIDAD_LOAD_REQUESTED:
      return { ...state, actividad: { ...state.actividad, loading: true } }
    case actions.ACTIVIDAD_LOAD_SUCCEEDED:
      return { ...state, actividad: { ...state.actividad, data: action.payload, loading: false } }
    case actions.ACTIVIDAD_LOAD_FAILED:
      return { ...state, actividad: { ...state.actividad, loading: false, error: action.error } }
    case actions.ERRONEOS_LOAD_REQUESTED:
      return { ...state, erroneos: { ...state.erroneos, loading: true } }
    case actions.ERRONEOS_LOAD_SUCCEEDED:
      return { ...state, erroneos: { ...state.erroneos, data: action.payload, loading: false } }
    case actions.ERRONEOS_LOAD_FAILED:
      return { ...state, erroneos: { ...state.erroneos, loading: false, error: action.error } }
    case actions.ERRONEOS_BY_ORIGEN_DESTINO_LOAD_REQUESTED:
      return {
        ...state,
        erroneosByOrigenDestino: { ...state.erroneosByOrigenDestino, loading: true },
      }
    case actions.ERRONEOS_BY_ORIGEN_DESTINO_LOAD_SUCCEEDED:
      return {
        ...state,
        erroneosByOrigenDestino: {
          ...state.erroneosByOrigenDestino,
          data: action.payload,
          loading: false,
        },
      }
    case actions.ERRONEOS_BY_ORIGEN_DESTINO_LOAD_FAILED:
      return {
        ...state,
        erroneosByOrigenDestino: {
          ...state.erroneosByOrigenDestino,
          loading: false,
          error: action.error,
        },
      }
    case actions.ERRONEO_UPDATE_REQUESTED:
      return { ...state, erroneos: { ...state.erroneos, loading: true } }
    case actions.ERRONEO_UPDATE_SUCCEEDED:
      return {
        ...state,
        erroneos: {
          ...state.erroneos,
          data: state.erroneos.data.map(erroneo =>
            erroneo.id === action.payload.id ? action.payload : erroneo,
          ),
          loading: false,
          error: '',
        },
        erroneo: { ...state.erroneos, data: action.payload, loading: false, error: '' },
      }
    case actions.ERRONEO_UPDATE_FAILED:
      return { ...state, erroneos: { ...state.erroneos, loading: false, error: action.error } }
    case actions.PROCESADOS_LOAD_REQUESTED:
      return { ...state, procesados: { ...state.procesados, loading: true } }
    case actions.PROCESADOS_LOAD_SUCCEEDED:
      return { ...state, procesados: { ...state.procesados, data: action.payload, loading: false } }
    case actions.PROCESADOS_LOAD_FAILED:
      return { ...state, procesados: { ...state.procesados, loading: false, error: action.error } }
    case actions.INSTANCIA_LOAD_REQUESTED:
      return { ...state, instancia: { ...state.instancia, loading: true } }
    case actions.INSTANCIA_LOAD_SUCCEEDED:
      return { ...state, instancia: { ...state.instancia, data: action.payload, loading: false } }
    case actions.INSTANCIA_LOAD_FAILED:
      return { ...state, instancia: { ...state.instancia, loading: false, error: action.error } }
    case actions.INSTANCIA_UPDATE_REQUESTED:
      return { ...state, instancia: { ...state.instancia, loading: true } }
    case actions.INSTANCIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        instancia: {
          ...state.instancia,
          data: state.instancia.data.map(i => (i.id === action.payload.id ? action.payload : i)),
          loading: false,
          error: '',
        },
      }
    case actions.INSTANCIA_UPDATE_FAILED:
      return { ...state, instancia: { ...state.instancia, loading: false, error: action.error } }
    default:
      return state
  }
}
